import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { useDesignContext } from '@klarna/designtokens';
import { isNative } from '@bubble-ui/util-platform';
import { offsetRenderStylesLineHeight } from '@bubble-ui/util-offset-render-lineheight';
export var useTextStyle = _ref => {
  var _klarnaFont$fontFamil, _klarnaFont$fontWeigh;
  var {
    addRenderingBox,
    colorToken,
    colorTokenArgs,
    designTokens,
    direction,
    fontFamily: fontFamilyProp,
    fontSize,
    fontWeight: fontWeightProp,
    letterSpacing,
    lineHeight: lineHeightProp,
    numberOfLines,
    shrink,
    textAlignToken,
    textAlignTokenArgs,
    textDecorationLine,
    textToken,
    textTokenArgs
  } = _ref;
  var designContext = useDesignContext(designTokens);
  var color = designContext.get(colorToken, colorTokenArgs).toString();
  var textStyle = designContext.get(textToken, textTokenArgs).styles();
  var textAlignment = textAlignToken ? designContext.get(textAlignToken, textAlignTokenArgs).value() : undefined;
  var isKlarnaFont = fontFamilyProp && designContext.hasTokenInContext(fontFamilyProp);
  var klarnaFont = isKlarnaFont ? designContext.get(fontFamilyProp) : undefined;
  var fontFamily = (_klarnaFont$fontFamil = klarnaFont === null || klarnaFont === void 0 ? void 0 : klarnaFont.fontFamily) !== null && _klarnaFont$fontFamil !== void 0 ? _klarnaFont$fontFamil : fontFamilyProp;
  var fontWeight = (_klarnaFont$fontWeigh = klarnaFont === null || klarnaFont === void 0 ? void 0 : klarnaFont.fontWeight) !== null && _klarnaFont$fontWeigh !== void 0 ? _klarnaFont$fontWeigh : fontWeightProp;
  var lineHeight = lineHeightProp !== null && lineHeightProp !== void 0 ? lineHeightProp : fontSize ? fontSize * 1.15 : undefined;
  return useMemo(() => {
    var numberOfLinesStyle = numberOfLines && !isNative ? {
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
      WebkitFontSmoothing: 'antialiased',
      WebkitLineClamp: "".concat(numberOfLines)
    } : {};

    // use negative margin on native to allow for glyphs exceeding the line-height
    // only makes sense if users override line height to <115% (which they do)
    var renderingOffsetStyles = addRenderingBox ? offsetRenderStylesLineHeight(textStyle.lineHeight) : {
      margin: 0,
      padding: 0
    };
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, renderingOffsetStyles), {}, {
      boxSizing: 'border-box',
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-word',
      textAlign: textAlignment === 'start' ? direction === 'rtl' ? 'right' : 'left' : textAlignment === 'end' ? direction === 'rtl' ? 'left' : 'right' : textAlignment
    }, direction ? isNative ? {
      writingDirection: direction
    } : {
      direction
    } : {}), {}, {
      textDecorationLine
    }, numberOfLinesStyle), textStyle), fontFamily ? {
      fontFamily
    } : {}), fontSize ? {
      fontSize
    } : {}), fontWeight ? {
      fontWeight
    } : {}), letterSpacing ? {
      letterSpacing
    } : {}), lineHeight ? {
      lineHeight
    } : {}), {}, {
      color
    }, isNative && shrink !== undefined ? {
      flexShrink: shrink === true ? 1 : shrink === false ? 0 : shrink
    } : {});
  }, [addRenderingBox, color, direction, fontFamily, fontSize, fontWeight, letterSpacing, lineHeight, numberOfLines, shrink, textAlignment, textDecorationLine, textStyle]);
};
//# sourceMappingURL=index.js.map